import React from 'react'
import styled from 'styled-components'
import { fontSizeResponsive, mediaQ } from '../../theme/mixins'

const DialogContainer = styled.div`
  width: 100%;
  background-color: #202020;
  position: fixed;
  width: 60%;
  left: 20%;
  height: 50vh;
  top: 25vh;
  padding: 3% 50px;
  box-sizing: border-box;
  box-shadow: 0 2.8px 2.2px rgba(0, 0, 0, 0.02),
    0 6.7px 5.3px rgba(0, 0, 0, 0.028), 0 12.5px 10px rgba(0, 0, 0, 0.035),
    0 22.3px 17.9px rgba(0, 0, 0, 0.042), 0 41.8px 33.4px rgba(0, 0, 0, 0.05),
    0 100px 80px rgba(0, 0, 0, 0.07);

  ${mediaQ('mobileAll', 'width: 90%; left: 5%; padding:3% 25px;')}
`

const DialogRow = styled.div`
  margin: ${(props) =>
    props.margin ? '25px 0' : props.marginBottom ? '0 0 10px 0' : 'unset'};
`

const DialogHeader = styled.span`
  color: #c7ff03;
  font-family: 'Asap Condensed';
  font-weight: bold;
  ${fontSizeResponsive(105)};
`

const DialogText = styled.span`
  color: white;
  font-weight: ${(props) => (props.bold ? 'bold' : 'normal')};
  font-family: 'Asap Condensed';
  ${fontSizeResponsive(35)};
  line-height: 2rem;

  ${mediaQ('mobileS', 'font-size: 17px; line-height:1.5rem ')}
`

const DialogButton = styled.button`
  background: linear-gradient(
    90deg,
    rgba(254, 13, 159, 1) 0%,
    rgba(250, 173, 2, 1) 100%
  );
  font-family: 'Asap Condensed';
  border: none;
  padding: 16px 30px;
  ${fontSizeResponsive(35)};
  color: white;
  position: absolute;
  bottom: 15%;
  right: 15%;
  border-radius: 4px;
  box-shadow: 0 2.3px 2.6px -18px rgba(0, 0, 0, 0.11),
    0 6.2px 6.2px -18px rgba(0, 0, 0, 0.158),
    0 12.9px 11.6px -18px rgba(0, 0, 0, 0.195),
    0 25.1px 20.8px -18px rgba(0, 0, 0, 0.232),
    0 50.9px 38.9px -18px rgba(0, 0, 0, 0.28),
    0 83px 93px -18px rgba(0, 0, 0, 0.39);
  transition: all 0.3s ease-in-out;

  &:hover {
    transform: scale(1.1);
  }

  ${mediaQ('mobileAll', 'bottom: -8%; right: 10%;')}
  ${mediaQ('mobileS', 'font-size: 22px; padding:12px 22px;')}
`

const WatchEntryDialog = ({ temporaryCloseDialog }) => {
  return (
    <DialogContainer>
      <DialogRow margin>
        <DialogHeader>Uwaga!</DialogHeader>
      </DialogRow>
      <DialogRow>
        <DialogRow marginBottom>
          <DialogText>
            Aby oglądać kolejne treningi najpierw musisz zobaczyć pierwszy film
            - wstęp.
          </DialogText>
        </DialogRow>
        <DialogRow>
          <DialogText bold>Ta zasada dotyczy każdego działu MIAZGA </DialogText>
        </DialogRow>
      </DialogRow>
      <DialogButton onClick={temporaryCloseDialog}>OK!</DialogButton>
    </DialogContainer>
  )
}

export default WatchEntryDialog
